import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { IAppState } from 'app/store';
import { PermissionService } from 'app/shared/services/permission.service';
import { Permission } from 'app/shared/models/permission';
import { KeyBase, IEntity, Key } from '@kpd/framework-ngx';
import { environment } from 'environments/environment';
import { UserManagementQueryFacade } from './usermanagement.facade';

@Injectable()
export class PermissionFacade extends UserManagementQueryFacade {
  constructor(permissionService: PermissionService, store: Store<IAppState>) {
    super('permissions', store, permissionService, environment);
  }

  saveItem(permission: Permission): Observable<Permission> {
    return of(permission);
  }

  composeKeyByRouteParams(params: { id: string }): KeyBase {
    return Key.composeKeyByRouteParams(params);
  }

  createNewEntity(): IEntity {
    return new Permission();
  }
}
